import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Camera, CheckCircle2, Target, Sparkles } from 'lucide-react';
import { AnimatedSection, AnimatedGrid, AnimatedGridItem } from '../components/AnimatedSection';
const BATHROOM_AFTER = 'https://cdn.magicpatterns.com/uploads/oEgW5paAq2Dk79weiW3TVs/Screenshot_20260602_204021_ChatGPT.jpg';
const BATHROOM_DETAIL = 'https://cdn.magicpatterns.com/uploads/aZCWMbBR6VMR4Qp2JDoydi/IMG_20260602_180800.jpg';
const METER_PANEL_INTERIOR = 'https://cdn.magicpatterns.com/uploads/tjg8zQ9b31BMwXPUfAefb8/Screenshot_20260602_211622_ChatGPT.jpg';
const METER_SERVICE_EXTERIOR = 'https://cdn.magicpatterns.com/uploads/spCvphBURh3V2k7w6Ge8Vp/Screenshot_20260602_211504_ChatGPT.jpg';
const METER_RESIDENTIAL = 'https://cdn.magicpatterns.com/uploads/3vpXh25EbSFYyxLoPqdWiW/Screenshot_20260602_212034_ChatGPT.jpg';
const METER_MOBILE_HOME = 'https://cdn.magicpatterns.com/uploads/gAAHGQLp4PHpsE5eyuUYD6/Screenshot_20260602_212133_ChatGPT.jpg';
const RESIDENTIAL_BEDROOM = 'https://cdn.magicpatterns.com/uploads/neQt3fa1hCVj55jjLBBk7D/Screenshot_20260602_212417_ChatGPT.jpg';
const RESIDENTIAL_KITCHEN = 'https://cdn.magicpatterns.com/uploads/9Zx7UbazjC1hPxTftPBivg/Screenshot_20260602_212447_ChatGPT.jpg';
export function Gallery() {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Residential', 'Commercial', 'Panel Upgrades', 'Lighting', 'Service Calls'];
  const projects = [{
    id: 1,
    category: 'Lighting',
    title: 'Custom Bathroom Lighting',
    img: BATHROOM_AFTER
  }, {
    id: 2,
    category: 'Lighting',
    title: 'Bathroom Wall Sconce Detail',
    img: BATHROOM_DETAIL
  }, {
    id: 13,
    category: 'Lighting',
    title: 'Kitchen Lighting Upgrade',
    img: RESIDENTIAL_KITCHEN
  }, {
    id: 14,
    category: 'Lighting',
    title: 'Recessed Bedroom Lighting',
    img: RESIDENTIAL_BEDROOM
  }, {
    id: 10,
    category: 'Panel Upgrades',
    title: 'Meter & Service Installation',
    img: METER_RESIDENTIAL
  }, {
    id: 11,
    category: 'Commercial',
    title: 'Commercial Service Equipment',
    img: METER_SERVICE_EXTERIOR
  }, {
    id: 12,
    category: 'Residential',
    title: 'Mobile Home Power Installation',
    img: METER_MOBILE_HOME
  }];
  const filteredProjects = filter === 'All' ? projects : projects.filter(p => p.category === filter);
  return <div className="w-full" data-id="element-197" data-mp="31h7p8xw3bd9r">
      {/* HERO SECTION */}
      <section className="relative bg-navy text-white py-24 md:py-32 overflow-hidden" data-id="element-198" data-mp="2wio2iv9o9xgc">
        <div className="absolute inset-0 z-0" data-id="element-199" data-mp="2sichvihb7x4v">
          <div className="absolute inset-0 bg-navy/90 mix-blend-multiply" data-id="element-200" data-mp="2sjnmfkikx8x1"></div>
          <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-201" data-mp="uqrs5oz8qtn5"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center" data-id="element-202" data-mp="qrizyojun3tp">
          <AnimatedSection data-id="element-203" data-mp="28omapbgt91e0">
            <Camera className="w-12 h-12 text-accent mx-auto mb-6" data-id="element-204" data-mp="28nb7bcra1vnf" />
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight mb-6 max-w-4xl mx-auto" data-id="element-205" data-mp="2dmnszu6ewwof">
              Project <span className="text-accent" data-id="element-206" data-mp="2iefjy5thd4f3">Gallery</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-207" data-mp="2meg1hzbvlvqd">
              A showcase of our professional electrical installations, upgrades,
              and service calls.
            </p>
          </AnimatedSection>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-2 bg-accent" data-id="element-208" data-mp="1uq64rmqrvewx"></div>
      </section>

      {/* FEATURED PROJECT */}
      <section className="py-20 md:py-28 bg-white" data-id="element-209" data-mp="23pj4hnp3gp4g">
        <div className="max-w-7xl mx-auto px-6" data-id="element-210" data-mp="23qb3l8hwh4zh">
          <AnimatedSection className="mb-12" data-id="element-211" data-mp="3a5lfsa264fyk">
            <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 px-3 py-1.5 rounded-full mb-4" data-id="element-212" data-mp="3a4tw9xlui8on">
              <Sparkles className="w-4 h-4 text-yellow-400" data-id="element-213" data-mp="3dmral5spkty4" />
              <span className="text-sm font-semibold tracking-wider text-yellow-400 uppercase" data-id="element-214" data-mp="3dn9feqtfsghn">
                Featured Project
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-4 tracking-tight" data-id="element-215" data-mp="3moqse0bjs224">
              Residential Lighting Upgrades
            </h2>
            <div className="w-20 h-1.5 bg-accent" data-id="element-216" data-mp="fxybp0zv6g5"></div>
          </AnimatedSection>

          {/* Project Images — 4 photo collage */}
          <AnimatedGrid className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" data-id="element-217" data-mp="3rlzegbztgq8n">
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-218" data-mp="a6kb7bhbtiv5">
              <img src={BATHROOM_AFTER} alt="Modern bathroom with custom pendant lighting and wall sconces" className="w-full h-full object-cover" data-id="element-219" data-mp="588xgpnwuo7n" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-220" data-mp="e5t2m9ow94nj">
              <img src={RESIDENTIAL_KITCHEN} alt="Updated kitchen lighting with pendant and recessed fixtures" className="w-full h-full object-cover" data-id="element-221" data-mp="xrl8bzav3u3h" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-222" data-mp="sttciu73jnu0">
              <img src={RESIDENTIAL_BEDROOM} alt="Bedroom with new recessed ceiling lighting installation" className="w-full h-full object-cover" data-id="element-223" data-mp="f2wqjm7oe4vx" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-224" data-mp="56tjc1xyvg24">
              <img src={BATHROOM_DETAIL} alt="Close-up of custom wall sconce lighting" className="w-full h-full object-cover" data-id="element-225" data-mp="a20l347oeaoe" />
            </AnimatedGridItem>
          </AnimatedGrid>

          {/* Description + Services */}
          <div className="grid lg:grid-cols-5 gap-12 mb-16" data-id="element-226" data-mp="22tvsj9w3lv2u">
            <AnimatedSection className="lg:col-span-3" data-id="element-227" data-mp="1y1m5q2qa5b4s">
              <h3 className="font-display text-2xl font-bold text-navy mb-4" data-id="element-228" data-mp="1y01bke7vnu7g">
                Project Description
              </h3>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-229" data-mp="1p1pnojyebaip">
                This project gallery showcases residential lighting upgrades
                completed by The Electrical Professionals Inc. These projects
                include bathroom lighting, kitchen lighting, recessed lighting,
                wall sconces, fixture replacements, LED lighting upgrades, and
                other interior lighting improvements designed to improve
                comfort, visibility, safety, and home appearance.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.2} className="lg:col-span-2" data-id="element-230" data-mp="1198w9isrq66q">
              <div className="bg-navy text-white p-8 rounded-sm relative overflow-hidden h-full" data-id="element-231" data-mp="waxmf82h3voi">
                <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-232" data-mp="381f71qzosxn8"></div>
                <div className="relative z-10" data-id="element-233" data-mp="3d0045hjn717g">
                  <h3 className="font-display text-xl font-bold mb-6" data-id="element-234" data-mp="3cwktqs0wygcd">
                    Services Included
                  </h3>
                  <ul className="space-y-3" data-id="element-235" data-mp="3lrilhvsbrn24">
                    {['Bathroom Lighting', 'Kitchen Lighting', 'Recessed Lighting', 'Wall Sconce Installation', 'Fixture Replacement', 'LED Lighting Upgrades', 'Interior Lighting Improvements'].map((service, i) => <li key={i} className="flex items-start gap-3" data-id="element-236" data-mp="8jxndvwtfg72" data-mpi={i}>
                        <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-237" data-mp="26bjtbtz3s1ni" />
                        <span className="text-slate-300 text-sm" data-id="element-238" data-mp="2abbvnoxwlbkf">
                          {service}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Project Highlights */}
          <AnimatedSection data-id="element-239" data-mp="207nbe6e0ts6w">
            <h3 className="font-display text-2xl font-bold text-navy mb-8 text-center" data-id="element-240" data-mp="209zree07xshb">
              Project Highlights
            </h3>
            <AnimatedGrid className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-241" data-mp="18g7fflqkqt40">
              {['Modern Lighting Solutions', 'Professional Fixture Installation', 'Improved Home Visibility', 'Energy-Efficient Options', 'Clean Finished Appearance', 'Safe, Reliable Workmanship'].map((highlight, i) => <AnimatedGridItem key={i} className="bg-slate-50 border border-slate-100 p-4 rounded-sm text-center" data-id="element-242" data-mp="2sv9e7cffcssp" data-mpi={i}>
                  <CheckCircle2 className="w-6 h-6 text-accent mx-auto mb-2" data-id="element-243" data-mp="2wei9jm4quib8" />
                  <p className="text-sm font-semibold text-navy leading-tight" data-id="element-244" data-mp="30g3k30tt2ki9">
                    {highlight}
                  </p>
                </AnimatedGridItem>)}
            </AnimatedGrid>
          </AnimatedSection>
        </div>
      </section>

      {/* FEATURED PROJECT — METER & SERVICE INSTALLATION */}
      <section className="py-20 md:py-28 bg-slate-50 border-t border-slate-200" data-id="element-245" data-mp="3f6aqujagaf34">
        <div className="max-w-7xl mx-auto px-6" data-id="element-246" data-mp="3k4ud6ksyhsw0">
          <AnimatedSection className="mb-12" data-id="element-247" data-mp="3k3j9ekzigl4w">
            <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 px-3 py-1.5 rounded-full mb-4" data-id="element-248" data-mp="35fybd5hhtc3u">
              <Sparkles className="w-4 h-4 text-yellow-400" data-id="element-249" data-mp="3acyfhaus84sb" />
              <span className="text-sm font-semibold tracking-wider text-yellow-400 uppercase" data-id="element-250" data-mp="1y7nwye7qloj">
                Featured Project
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-4 tracking-tight" data-id="element-251" data-mp="6r98nn13pfg1">
              Electrical Service, Meter & Mobile Home Power Installation
            </h2>
            <div className="w-20 h-1.5 bg-accent" data-id="element-252" data-mp="7u5ud5shk85b"></div>
          </AnimatedSection>

          {/* Photo collage — 4 images */}
          <AnimatedGrid className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-253" data-mp="3v0q32tsbmkq0">
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg md:row-span-2" data-id="element-254" data-mp="3v32hwy2s8eyu">
              <img src={METER_MOBILE_HOME} alt="Mobile home electrical service and meter installation by TEP" className="w-full h-full object-cover" data-id="element-255" data-mp="3l2s8lojvbroy" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[4/3] overflow-hidden rounded-sm shadow-lg" data-id="element-256" data-mp="3bds5pu28wc5h">
              <img src={METER_SERVICE_EXTERIOR} alt="Exterior commercial electrical service equipment with conduit installed by TEP" className="w-full h-full object-cover" data-id="element-257" data-mp="2xdzhc5e6y80o" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[4/3] overflow-hidden rounded-sm shadow-lg" data-id="element-258" data-mp="2dsh5wfkawbw8">
              <img src={METER_PANEL_INTERIOR} alt="Interior labeled breaker panel installation" className="w-full h-full object-cover" data-id="element-259" data-mp="2sp878udjbxoh" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[4/3] overflow-hidden rounded-sm shadow-lg md:col-span-2" data-id="element-260" data-mp="31o21wf7b2dze">
              <img src={METER_RESIDENTIAL} alt="Residential exterior meter and service panel installation" className="w-full h-full object-cover" data-id="element-261" data-mp="2woh2k3o843m5" />
            </AnimatedGridItem>
          </AnimatedGrid>

          {/* Description + Services */}
          <div className="grid lg:grid-cols-5 gap-12 mb-16" data-id="element-262" data-mp="3kdrtyujoolnm">
            <AnimatedSection className="lg:col-span-3" data-id="element-263" data-mp="3gfu37na9lri4">
              <h3 className="font-display text-2xl font-bold text-navy mb-4" data-id="element-264" data-mp="3nhzay8obln9a">
                Project Description
              </h3>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-265" data-mp="3shve65p71ans">
                This project showcases a professionally completed electrical
                service and meter installation performed by The Electrical
                Professionals Inc. Our team installed and configured electrical
                service equipment, conduit, distribution components, and mobile
                home power connections with a focus on safety, reliability, and
                code-compliant workmanship.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.2} className="lg:col-span-2" data-id="element-266" data-mp="jz5xdvvjkyf4">
              <div className="bg-navy text-white p-8 rounded-sm relative overflow-hidden h-full" data-id="element-267" data-mp="ozlf0zmuws2w">
                <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-268" data-mp="2ltycpag8nr69"></div>
                <div className="relative z-10" data-id="element-269" data-mp="2qs9i98zi3fio">
                  <h3 className="font-display text-xl font-bold mb-6" data-id="element-270" data-mp="17wc1l0c0vwj7">
                    Services Provided
                  </h3>
                  <ul className="space-y-3" data-id="element-271" data-mp="135di5rvqmibq">
                    {['Electrical Service Installation', 'Meter Equipment Installation', 'Mobile Home Electrical Service', 'Mobile Home Power Connections', 'Service Upgrades', 'Conduit Installation', 'Electrical Distribution', 'Safety Testing & Verification'].map((service, i) => <li key={i} className="flex items-start gap-3" data-id="element-272" data-mp="1hsyn7rc6arma" data-mpi={i}>
                        <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-273" data-mp="1cw85z0omtpza" />
                        <span className="text-slate-300 text-sm" data-id="element-274" data-mp="6fw7szlt883p">
                          {service}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Project Highlights */}
          <AnimatedSection className="mb-16" data-id="element-275" data-mp="1u4hl1o9fm256">
            <h3 className="font-display text-2xl font-bold text-navy mb-8 text-center" data-id="element-276" data-mp="1gc9q821pkl94">
              Project Highlights
            </h3>
            <AnimatedGrid className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-4" data-id="element-277" data-mp="1lakxc50mchnn">
              {['Mobile Home Electrical Expertise', 'Clean Professional Installation', 'Code-Compliant Workmanship', 'Reliable Power Distribution', 'Residential & Commercial Experience', 'Safety-Focused Design', 'Long-Term Reliability'].map((highlight, i) => <AnimatedGridItem key={i} className="bg-white border border-slate-100 p-4 rounded-sm text-center shadow-sm" data-id="element-278" data-mp="nn2rp3297vnv" data-mpi={i}>
                  <CheckCircle2 className="w-6 h-6 text-accent mx-auto mb-2" data-id="element-279" data-mp="l362tnx5cry8" />
                  <p className="text-sm font-semibold text-navy leading-tight" data-id="element-280" data-mp="l5aguyorf7c8">
                    {highlight}
                  </p>
                </AnimatedGridItem>)}
            </AnimatedGrid>
          </AnimatedSection>

          {/* Benefit & Outcome */}
          <AnimatedGrid className="grid md:grid-cols-2 gap-6" data-id="element-281" data-mp="p5aw2ljonmkc">
            <AnimatedGridItem className="bg-white border-l-4 border-yellow-400 p-8 rounded-sm shadow-sm" data-id="element-282" data-mp="1ep19vyovysa">
              <div className="flex items-center gap-3 mb-4" data-id="element-283" data-mp="3tjsk8n3r9ypi">
                <Target className="w-6 h-6 text-yellow-400" data-id="element-284" data-mp="3th6duqslpp8v" />
                <h4 className="font-display font-bold text-xl text-navy" data-id="element-285" data-mp="b5ry2lkl5rlr">
                  Customer Benefit
                </h4>
              </div>
              <p className="text-slate-600 leading-relaxed" data-id="element-286" data-mp="3eu3cua52kygs">
                A safe, dependable electrical service installation designed to
                provide reliable power while meeting current electrical
                standards and future electrical needs.
              </p>
            </AnimatedGridItem>

            <AnimatedGridItem className="bg-white border-l-4 border-accent p-8 rounded-sm shadow-sm" data-id="element-287" data-mp="1iqf4nh41pzub">
              <div className="flex items-center gap-3 mb-4" data-id="element-288" data-mp="1nhf34qstcpyx">
                <Sparkles className="w-6 h-6 text-accent" data-id="element-289" data-mp="1nk1aapbsl3gm" />
                <h4 className="font-display font-bold text-xl text-navy" data-id="element-290" data-mp="1sfgmzdy2ctbg">
                  Outcome
                </h4>
              </div>
              <p className="text-slate-600 leading-relaxed" data-id="element-291" data-mp="uvcixi0jgci2">
                The completed installation provides efficient, reliable
                electrical service with a clean and professional appearance that
                reflects our commitment to quality workmanship and customer
                satisfaction.
              </p>
            </AnimatedGridItem>
          </AnimatedGrid>
        </div>
      </section>

      {/* GALLERY SECTION */}
      <section className="py-20 md:py-28 bg-slate-50 border-y border-slate-200" data-id="element-292" data-mp="2k6wjq0tc3wfe">
        <div className="max-w-7xl mx-auto px-6" data-id="element-293" data-mp="8kuayq65ji3q">
          <AnimatedSection className="text-center max-w-2xl mx-auto mb-12" data-id="element-294" data-mp="8mox27t5tg9e">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-navy mb-4 tracking-tight" data-id="element-295" data-mp="4kahbwksewmc">
              More Projects
            </h2>
            <div className="w-20 h-1.5 bg-accent mx-auto" data-id="element-296" data-mp="3qyli1z5tf2gk"></div>
          </AnimatedSection>

          {/* Filters */}
          <AnimatedSection className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-297" data-mp="3m00fht33c6oy">
            {categories.map(cat => <button key={cat} onClick={() => setFilter(cat)} className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors ${filter === cat ? 'bg-navy text-white' : 'bg-white text-slate-600 hover:bg-slate-200 border border-slate-200'}`} data-id="element-298" data-mp="3gzmgt1ndq93l">
                {cat}
              </button>)}
          </AnimatedSection>

          {/* Grid */}
          <AnimatedGrid className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-299" data-mp="1694hnigvuu16">
            {filteredProjects.map(project => <AnimatedGridItem key={project.id} className="group relative aspect-[4/3] overflow-hidden rounded-sm bg-slate-100 shadow-sm" data-id="element-300" data-mp="k2lgahp1w7s5">
                <img src={project.img} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-301" data-mp="ac0kf20rhhcx" />
                <div className="absolute inset-0 bg-navy/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-6 text-center" data-id="element-302" data-mp="ecldzw4hnoy">
                  <span className="text-yellow-400 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-303" data-mp="3niaer22tsggv">
                    {project.category}
                  </span>
                  <h3 className="text-white font-display text-xl font-bold" data-id="element-304" data-mp="1gqjdvtcj6p35">
                    {project.title}
                  </h3>
                </div>
              </AnimatedGridItem>)}
          </AnimatedGrid>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white" data-id="element-305" data-mp="31by8n4dtmd5j">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-306" data-mp="3fz14z7qeqfra">
          <AnimatedSection data-id="element-307" data-mp="3g0m131sde6r9">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-308" data-mp="3b8kt3s28j271">
              Like what you see?
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-309" data-mp="3oyy09s7aycvb">
              Let's add your project to our gallery. Contact us today for a free
              estimate.
            </p>
            <Link to="/quote" className="bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-sm font-bold text-lg transition-colors inline-block" data-id="element-310" data-mp="2tau4stn6d3h">
              Request a Free Quote
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}